import type { CSSProperties } from "react";

import type { TrustLogo } from "@/content/trust";

type TrustLogoMarkProps = {
  logo: TrustLogo;
  /** The marquee's repeated copy: no role or name, so each company is announced once. */
  decorative?: boolean;
};

/**
 * One trusted-by mark: its SVG drawn through a mask in the current text color,
 * sized by the band's logo height times the logo's optical scale.
 */
export const TrustLogoMark = ({
  logo,
  decorative = false,
}: TrustLogoMarkProps) => (
  <span
    className="trust-logo-mark"
    {...(decorative ? {} : { role: "img", "aria-label": logo.label })}
    style={
      {
        "--trust-logo-src": `url("${logo.src}")`,
        "--trust-logo-ratio": logo.aspectRatio,
        "--trust-logo-scale": logo.scale,
      } as CSSProperties
    }
  />
);
